export default "__VITE_ASSET__LnHnnj$T__"